import drawingLayerTypes from 'helpers/enums/drawingLayerTypes'
import layerActionTypes from 'components/drawit/helpers/layerActionTypes'

function loadImage(imageData) {
	return new Promise(res => {
		const img = document.createElement('img')
		img.setAttribute('crossorigin', 'Anonymous')
		img.src = imageData.file.link
		img.onload = () => {
			res({
				data: imageData,
				img,
			})
		}
	})
}

function loadImages(imageList) {
	return Promise.all(imageList.map(image => loadImage(image)))
}

function getImageList(actions) {
	return new Promise(res => {
		const imageList = actions.filter(action => action.type === drawingLayerTypes.IMAGE)
			.reduce((accumulator, element) => {
				accumulator[element.index]=element
				return accumulator
			}, [])
			.filter(element => element.actionType !== layerActionTypes.ERASE)
		res(imageList)
	})
}

function drawImages(imageList, width, height) {
	return new Promise(res => {
		const canvas = document.createElement('canvas')
		canvas.width = width
		canvas.height = height
		const ctx = canvas.getContext('2d')
		imageList.forEach(image => {
			ctx.save()
			const data = image.data
			const matrix = data.matrix
			ctx.translate(-(image.img.width * matrix[0])/ 2, -(image.img.height * matrix[3]) / 2)
			ctx.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5])
			////
			ctx.translate((image.img.width)/ 2, (image.img.height) / 2)
			ctx.rotate(data.rotate * Math.PI / 180)
			ctx.scale(data.xDir, data.yDir)
			ctx.translate(-(image.img.width)/ 2, -(image.img.height) / 2)
			ctx.drawImage(image.img, 0, 0)
			ctx.restore()
		})
		res(canvas)
	})
}

function saveImages(actions, width, height) {
	return new Promise(res => {
		getImageList(actions)
			.then(loadImages)
			.then(imageList => drawImages(imageList, width, height))
			.then(res)
	})
}

export default saveImages
